/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0L20 7.42157V12.4558H17V16.4558H20V23.4558H0V16.4558H3V12.4558H0V7.42157L10 0ZM10 2.45091L2 8.45581V10.4558H5V18.4558H2V21.4558H18V18.4558H15V10.4558H18V8.45581L10 2.45091ZM7 10.4558H13V18.4558H7V10.4558ZM9 12.4558V16.4558H11V12.4558H9Z"
        fill="currentColor"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconDeals24';

export const IconDeals24: React.FC<ISVGIconProps> = createIcon(IconComponent);
